import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveBar } from 'cccisd-nivo/bar';
import { round, mean } from 'lodash';

const SubscaleChart = props => {
    const { data, subscales } = props;

    const getData = d => {
        const rows = [];
        const ccmap = {};

        for (const subscale of subscales) {
            const subscaleCcScores = {};

            for (const item of subscale.items) {
                for (const cc of d.flows[item].frequency) {
                    if (cc.value) {
                        if (!ccmap[cc.value]) {
                            ccmap[cc.value] = {};
                        }

                        if (!subscaleCcScores[cc.value]) {
                            subscaleCcScores[cc.value] = [];
                        }

                        if (cc.avg !== null) {
                            subscaleCcScores[cc.value].push(cc.avg);
                        }
                    }
                }
            }

            for (const cc of Object.keys(subscaleCcScores)) {
                if (subscaleCcScores[cc].length === 0) {
                    continue;
                }

                ccmap[cc][subscale.name] = mean(subscaleCcScores[cc]) * 100;
            }
        }

        for (const cc of Object.keys(ccmap)) {
            const row = {
                cc,
                careCoord: cc.split(', ')[0],
            };

            for (const subscale of subscales) {
                row[subscale.name] = typeof ccmap[cc][subscale.name] === 'number' ? ccmap[cc][subscale.name] : null;
            }

            rows.push(row);
        }

        let total = { careCoord: 'Total: ', cc: 'totalRow' };
        for (const subscale of subscales) {
            const keyTotal = [];
            for (const row of rows) {
                if (row[subscale.name] !== null) {
                    keyTotal.push(row[subscale.name]);
                }
            }

            if (keyTotal.length) {
                total[subscale.name] = `${round(mean(keyTotal), 2)}%`;
            }
        }

        const bars = [];
        for (const subscale of subscales) {
            const value = total[subscale.name];
            if (value) {
                bars.push({
                    subscale: subscale.label,
                    score: parseFloat(value.replace('%', ''), 10),
                });
            }
        }

        return bars;
    };

    const chartData = getData(data);

    if (!chartData.length > 0) {
        return (
            <div style={{ width: '770px', height: '300px', textAlign: 'center' }}>
                <h2 style={{ marginTop: '125px' }}>No data</h2>
            </div>
        );
    }

    const longestLabel = Math.max(
        ...chartData.map(o => {
            return o.subscale.length;
        })
    );

    return (
        <div style={{ width: '770px', height: `${300 + 6.5 * longestLabel}px` }}>
            <ResponsiveBar
                indexBy="subscale"
                maxValue={100}
                labelFormat={d => <tspan y={-8}>{d}</tspan>}
                labelSkipWidth={0}
                labelSkipHeight={1}
                keys={['score']}
                theme={{ fontSize: 16 }}
                axisBottom={{ tickRotation: 45 }}
                data={chartData}
                margin={{ top: 15, right: 150, bottom: 6.5 * longestLabel, left: 50 }}
            />
        </div>
    );
};

SubscaleChart.propTypes = {
    data: PropTypes.object,
    subscales: PropTypes.array,
};

export default SubscaleChart;
